// extracted by mini-css-extract-plugin
export var fadeInAnimation = "slashlist-module--fadeInAnimation--f4530";
export var list = "slashlist-module--list--da0c1";
export var technologies = "slashlist-module--technologies--32b75";
export var technologiesItem = "slashlist-module--technologiesItem--c76f3";